var React = require('react');

function BbLogoWhiteInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M26.8481 0H39.4557L56.4991 43.3236H40.1556L40.3924 67.1903H0L26.8481 0Z","fill":"white","key":0}),React.createElement("path",{"d":"M68.0217 47.4717H44.1849V71H68.0217V47.4717Z","fill":"white","key":1})]);
}

BbLogoWhiteInline.defaultProps = {"width":"69","height":"71","viewBox":"0 0 69 71","fill":"none"};

module.exports = BbLogoWhiteInline;

BbLogoWhiteInline.default = BbLogoWhiteInline;
